import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Stack } from 'components/Stack'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SUpsellModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
`

export const SDivider = styled.div`
  width: 100%;
  height: 1px;
  background: var(--c-blue100);
`

export const SHeaderSection = styled.div`
  display: grid;
  grid-template-columns: ${pxToRem(365)}rem 1fr;
  grid-column-gap: 1.5rem;
  grid-row-gap: 1rem;
  width: 100%;

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;
    & > *:first-child {
      grid-row: 2;
      text-align: center;
      justify-self: center;
    }
  }
`

export const SHeaderTextStack = styled(Stack)`
  max-width: 365px;
`

export const SPictureWrapper = styled.div`
  justify-self: end;
  height: 120px;
  overflow: hidden;
  display: flex;
  align-items: center;

  @media ${BREAKPOINTS.MD.max} {
    justify-self: center;
  }
`

export const SPerkGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 0.5rem;
  grid-column-gap: 1.5rem;
  width: 100%;

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;
  }
`

export const SButtonGrid = styled.div<{ orientation: 'vertical' | 'horizontal' }>`
  display: grid;
  ${(p) =>
    p.orientation === 'horizontal'
      ? css`
          grid-template-columns: 1fr 1fr;
        `
      : css`
          grid-template-columns: 1fr;
          & > *:first-child {
            grid-row: 2;
          }
        `}
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  width: 100%;

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;
    & > *:first-child {
      grid-row: 2;
    }
  }
`
